/* ══════════════════════════════════════════════
   PDP TITLE ROW — move wishlist button inline with title
══════════════════════════════════════════════ */
function initPdpTitleRow() {
  const heading = document.querySelector('.product-details h2');
  const btn = document.querySelector('.product-details button.pdp-wishlist-btn');

  if (!heading || !btn) return;
  if (heading.closest('.pdp-title-row')) return;

  const row = document.createElement('div');
  row.className = 'pdp-title-row';

  heading.parentElement.insertBefore(row, heading);
  row.appendChild(heading);
  row.appendChild(btn);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpTitleRow);
} else {
  initPdpTitleRow();
}

document.addEventListener('shopify:section:load', initPdpTitleRow);
document.addEventListener('shopify:block:select', initPdpTitleRow);


(function() {
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('shopify_wishlist') || '[]'); } catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem('shopify_wishlist', JSON.stringify(list));
  }

  function updateButtons() {
    const ids = getWishlist().map(i => String(i.id));
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      btn.classList.toggle('is-wishlisted', ids.includes(String(btn.dataset.productId)));
    });
  }

  function updateHeaderCount() {
    const badge = document.getElementById('wishlist-header-count');
    if (!badge) return;
    const count = getWishlist().length;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function updateAll() { updateButtons(); updateHeaderCount(); }

  function cleanUrl(url) {
    try { return new URL(url, window.location.origin).pathname; }
    catch(e) { return url.split('?')[0]; }
  }

  function getProductUrl(btn) {
    if (btn.dataset.productUrl) return cleanUrl(btn.dataset.productUrl);
    const card = btn.closest('product-card') || btn.closest('.card-gallery');
    if (card) {
      const link = card.querySelector('a[href*="/products/"]');
      if (link) return cleanUrl(link.getAttribute('href'));
    }
    if (window.location.pathname.includes('/products/')) return window.location.pathname;
    return '';
  }

  function handleWishlistClick(btn) {
    if (btn._wishlistProcessing) return;
    btn._wishlistProcessing = true;
    setTimeout(() => { btn._wishlistProcessing = false; }, 500);

    const id = String(btn.dataset.productId);
    if (!id || id === 'undefined') return;

    const productUrl = getProductUrl(btn);
    var list = getWishlist();
    var idx = list.findIndex(i => String(i.id) === id);

    if (idx > -1) {
      list.splice(idx, 1);
      saveWishlist(list);
      btn.classList.remove('is-wishlisted');
      btn.classList.add('wishlist-pop');
      setTimeout(() => btn.classList.remove('wishlist-pop'), 300);
      updateAll();
    } else {
      const addToList = function(data) {
        var current = getWishlist();
        if (current.find(i => String(i.id) === id)) return;
        current.push(data);
        saveWishlist(current);
        btn.classList.add('is-wishlisted');
        btn.classList.add('wishlist-pop');
        setTimeout(() => btn.classList.remove('wishlist-pop'), 300);
        updateAll();
      };

      const fetchUrl = productUrl ? productUrl + '.js' : null;
      if (fetchUrl) {
        fetch(fetchUrl)
          .then(r => r.json())
          .then(p => addToList({
            id: id,
            title: p.title || btn.dataset.productTitle || '',
            url: productUrl,
            image: p.featured_image ? 'https:' + p.featured_image : (p.images?.[0] ? 'https:' + p.images[0] : ''),
            price: 'CAD $' + (p.price ? (p.price / 100).toFixed(2) : '0.00')
          }))
          .catch(() => addToList({
            id: id,
            title: btn.dataset.productTitle || '',
            url: productUrl,
            image: btn.dataset.productImage || '',
            price: btn.dataset.productPrice || ''
          }));
      } else {
        addToList({
          id: id,
          title: btn.dataset.productTitle || '',
          url: productUrl,
          image: btn.dataset.productImage || '',
          price: btn.dataset.productPrice || ''
        });
      }
    }
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    handleWishlistClick(btn);
  }, true);

  window.addEventListener('storage', function(e) {
    if (e.key === 'shopify_wishlist') updateAll();
  });

  new MutationObserver(function(mutations) {
    let hasNew = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('wishlist-btn') || node.querySelector?.('.wishlist-btn')) hasNew = true;
      });
    });
    if (hasNew) updateAll();
  }).observe(document.body, { childList: true, subtree: true });

  updateAll();
  setTimeout(updateAll, 500);
  setTimeout(updateAll, 1200);
})();
